import styled from 'styled-components';
import theme from 'src/styles/theme';

interface Props {
  displayTop?: boolean;
}

export const ContextDropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`;

export const MoreButtondWrapper = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px;
  border: none;
  border-radius: 50px;
  background-color: transparent;
  color: ${theme.colors.neutralW40};
  width: 32px;
  height: 32px;
  cursor: pointer;

  &:hover {
    background: ${theme.colors.white0};
  }
`;

export const ContextDropdownBox = styled.div<Props>`
  position: absolute;
  ${(props) => (props.displayTop ? 'bottom: 100%;' : 'top: 100%;')}
  right: 0;
  margin-top: 8px;
  border-radius: 5px;
  background: ${theme.colors.white0};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
  width: 204px;
  z-index: 1000;
`;

export const ContextDropdownList = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding-top: 2px;
  padding-bottom: 2px;
  gap: 8px;
`;

export const DropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  padding: 8px 16px;
  width: 100%;
  cursor: pointer;
  color: ${theme.colors.neutralW40};

  &:hover {
    background: ${theme.colors.neutralW100};
  }
`;

export const DropdownItemNoCSV = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  padding: 8px 16px;
  width: 100%;
  cursor: pointer;
  color: ${theme.colors.neutralW70};
`;
